import { z } from 'zod';
/**
 * calendar#165: a provider's specialties, edited on the Provider Profile (About > Specialties)
 * and read by the Calendar to match clients with providers. Agreed contract with the Calendar:
 *
 *   users."providerProfile".specialties  a JSON array of plain strings, e.g. ["Anxiety","Couples"]
 *
 * Each entry is trimmed (runs of spaces inside become one), at most 60 characters; no two entries
 * are the same ignoring case (the first spelling wins); at most 30 entries. A missing key, or
 * anything that is not an array, means none. The Provider Profile save stores the list already
 * normalized, so readers can take it as is (but should still treat a non-array as empty).
 */
export const MAX_SPECIALTIES = 30;
export const MAX_SPECIALTY_CHARS = 60;
/** The short pick list the Provider Profile offers; anything else may be typed in. */
export const SPECIALTY_SUGGESTIONS = [
    'Anxiety',
    'Depression',
    'Trauma / PTSD',
    'Couples',
    'Family',
    'Child & adolescent',
    'Substance use',
    'Grief',
    'Eating disorders',
    'OCD',
    'ADHD',
    'LGBTQ+',
];
/** A stored or posted value → the clean list (see the rules above). Never throws. */
export function normalizeSpecialties(raw) {
    if (!Array.isArray(raw))
        return [];
    const out = [];
    const seen = new Set();
    for (const v of raw) {
        if (typeof v !== 'string')
            continue;
        const s = v.replace(/\s+/g, ' ').trim().slice(0, MAX_SPECIALTY_CHARS).trim();
        if (!s)
            continue;
        const key = s.toLowerCase();
        if (seen.has(key))
            continue;
        seen.add(key);
        out.push(s);
        if (out.length >= MAX_SPECIALTIES)
            break;
    }
    return out;
}
/** The profile save's `specialties` field: accepts anything, stores the normalized list. */
export const providerSpecialtiesSchema = z.unknown().transform(normalizeSpecialties);
//# sourceMappingURL=providerSpecialties.js.map